import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Reassign-handoff modal for the scheduler panel. Extracted from
// SchedulableItemsPanel.tsx (P2).
import { useEffect, useState } from "react";
import { api } from "../../api/client";
export function ReassignHandoffModal({ kill, onClose, onSubmitted, }) {
    const [coworkers, setCoworkers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [toUserId, setToUserId] = useState("");
    const [note, setNote] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const list = await api.get("/users/coworkers");
                if (!cancelled)
                    setCoworkers(list);
            }
            catch (e) {
                if (!cancelled)
                    setError(e instanceof Error ? e.message : "Couldn't load coworkers");
            }
            finally {
                if (!cancelled)
                    setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);
    async function submit() {
        if (!toUserId)
            return;
        // Resolve the target Task. Direct task kills use task_id; checklist
        // kills need a lookup hop, but the kill row already carries task_id
        // via the source ref so we can rely on the backend resolving it from
        // either ref. POST endpoint is task-scoped, so we need a task_id.
        // For kills sourced from checklist items, we don't have the task_id
        // directly on KillListItem in this client view. Fall back to alert.
        const targetTaskId = kill.task_id;
        if (!targetTaskId) {
            setError("This kill row isn't linked to a task we can hand off — open the project first to reassign at the task level.");
            return;
        }
        setSubmitting(true);
        setError(null);
        try {
            await api.post(`/tasks/${targetTaskId}/handoff`, {
                to_user_id: toUserId,
                note: note.trim() || null,
            });
            onSubmitted();
        }
        catch (e) {
            setError(e instanceof Error ? e.message : "Couldn't request reassign");
        }
        finally {
            setSubmitting(false);
        }
    }
    return (_jsx("div", { className: "modal-backdrop", onClick: onClose, children: _jsxs("div", { className: "modal", onClick: (e) => e.stopPropagation(), children: [_jsx("h2", { children: "Request reassignment" }), _jsxs("p", { className: "muted small", style: { marginTop: "-0.5rem" }, children: [kill.project_name ? `${kill.project_name} — ` : "", kill.title] }), _jsx("p", { className: "muted small", children: "A manager or admin must approve before the task actually changes hands." }), _jsxs("label", { children: ["Coworker", _jsxs("select", { value: toUserId, onChange: (e) => setToUserId(e.target.value), disabled: loading, children: [_jsx("option", { value: "", children: loading
                                        ? "Loading…"
                                        : coworkers.length === 0
                                            ? "No teammates available"
                                            : "Pick a teammate…" }), coworkers.map((u) => (_jsxs("option", { value: u.id, children: [u.name, " (", u.email, ")"] }, u.id)))] })] }), _jsxs("label", { children: ["Note ", _jsx("span", { className: "muted small", children: "\u00B7 optional" }), _jsx("textarea", { rows: 3, placeholder: "Context for the reviewer \u2014 what's done, what's left.", value: note, onChange: (e) => setNote(e.target.value) })] }), error && _jsx("div", { className: "error", children: error }), _jsxs("div", { className: "modal-actions", children: [_jsx("button", { onClick: onClose, disabled: submitting, children: "Cancel" }), _jsx("button", { className: "btn-primary", onClick: submit, disabled: submitting || !toUserId, children: submitting ? "Submitting…" : "Request reassign" })] })] }) }));
}
